import type { EducationalAdvisorPendingActionsVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const educationalAdvisorRetrievePendingActions = createApiThunk<EducationalAdvisorPendingActionsVM, void>(
  "educationalAdvisor/educationalAdvisorRetrievePendingActions",
  async (_: void, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.hasPendingActions();
  },
);
